import { Link } from "react-router-dom";
import { imgUrl } from "../lib/api";
import { Sparkles, ArrowUpRight } from "lucide-react";

export function StudioShell({ title, subtitle, children, onGenerate, generating, disabled, result, generateLabel = "Generate" }) {
  return (
    <div className="min-h-screen">
      <header className="h-16 border-b border-zinc-200 bg-white flex items-center px-8 sticky top-0 z-30">
        <div>
          <h1 className="font-heading font-semibold text-lg leading-tight">{title}</h1>
          <p className="text-xs text-zinc-400">{subtitle}</p>
        </div>
      </header>
      <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[calc(100vh-4rem)]">
        <div className="lg:col-span-2 border-r border-zinc-200 bg-white p-8 space-y-6">
          {children}
          <button data-testid="studio-generate-button" onClick={onGenerate} disabled={disabled || generating}
            className="w-full flex items-center justify-center gap-2 bg-zinc-950 text-white py-3.5 rounded-md font-medium hover:bg-zinc-800 transition-colors disabled:opacity-40">
            {generating ? (
              <><span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Generating…</>
            ) : (
              <><Sparkles size={16} /> {generateLabel}</>
            )}
          </button>
          {generating && <p className="text-xs text-zinc-400 text-center">AI rendering in progress — usually 15–30 seconds.</p>}
        </div>
        <div className="lg:col-span-3 p-8">
          {result ? (
            <div className="fade-up">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-400">Result</p>
                  <h2 className="font-heading font-semibold" data-testid="studio-result-title">{result.title}</h2>
                </div>
                <Link to={`/designs/${result.id}`} data-testid="studio-open-design-link"
                  className="inline-flex items-center gap-1.5 text-sm font-medium border border-zinc-300 px-4 py-2 rounded-md hover:bg-zinc-100 transition-colors">
                  Open design <ArrowUpRight size={14} />
                </Link>
              </div>
              <img data-testid="studio-result-image" src={imgUrl(result.cover_image)} alt={result.title}
                className="w-full max-h-[70vh] object-contain rounded-md border border-zinc-200 bg-white" />
              <p className="mt-3 text-xs text-zinc-400">{result.versions?.length || 1} iteration{(result.versions?.length || 1) > 1 ? "s" : ""} saved to Designs</p>
            </div>
          ) : (
            <div className="h-full min-h-[400px] border-2 border-dashed border-zinc-200 rounded-md flex flex-col items-center justify-center text-zinc-400">
              <Sparkles size={28} className="mb-4" />
              <p className="text-sm">Your render will appear here</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
